import React from "react";
import Notifications from "components/newSettings/Settings.notifications";
import Substitute from "components/newSettings/Settings.substitute";
import Preferences from "components/newSettings/Settings.preferences";

export const NewSettingsMainPage = (): React.ReactElement => {

    return <main className="d-flex justify-content-center align-items-start">
        <div className={"py-16 w-50 mt-24"}>
            <h2>Approval settings</h2>
            <div className={"mb-2 bg-white"}>
                <Notifications/>
            </div>
            <div className={"mb-2 bg-white"}>
                <Substitute/>
            </div>
            <div className={"mb-2 bg-white"}>
                <Preferences/>
            </div>
        </div>
    </main>


}

export default NewSettingsMainPage;